import { Stack, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import type { FC } from ".."

export interface FormHeadingProps {
  intro1: string
  intro2: string
  introKeyword1: string
  introKeyword2: string
  description: string
}

const FormHeading: FC<FormHeadingProps> = ({
  intro1,
  intro2,
  introKeyword1,
  introKeyword2,
  description,
}) => {
  return (
    <Stack gap={8}>
      <StyledTypography
        variant="heading.md"
        sx={(theme) => ({
          color: theme.palette["primary.800"].main,
          fontSize: { xs: "36px!important", md: "56px!important" },
        })}
      >
        {intro1}
        <span
          style={{
            display: "inline-block",
            fontWeight: 400,
            fontStyle: "italic",
            padding: "0 6px",
          }}
        >
          {introKeyword1}
        </span>
        {intro2}
        <span
          style={{
            display: "inline-block",
            fontWeight: 400,
            fontStyle: "italic",
            padding: "0 6px",
          }}
        >
          {introKeyword2}
        </span>
      </StyledTypography>
      <StyledTypography
        variant="body.md"
        sx={(theme) => ({
          fontSize: "16px!important",
          fontWeight: 400,
          lineHeight: "140%!important",
        })}
      >
        {description}
      </StyledTypography>
    </Stack>
  )
}

export default FormHeading

// A styled typography component
const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette["neutral.700"].main,
  fontSize: "56px!important",
  fontWeight: 700,
  lineHeight: "110%!important",
}))
